import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import classnames from 'classnames';

import datastore from '@datastore';
import { buttonsV2 as Buttons, bars as Bars } from '@breezeway/brzw-components';
import { format } from '@breezeway/brzw-react-core';
import * as selectors from '../../../../schedule/selectors';
import AssignmentBar from '../../assignment_bar';
import AvailabilityBar from '../../availability_bar';
import { searchObjects } from '../../../utils/search';
import SearchInputWithState from '../../forms/v2/search_input_with_state';
import Avatar from '../../avatar';
import Modal from '../../modal';

import './modal_select.scss';

const { formatDate } = format.datetime;

export class ModalSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchFilter: '',
    };

    this.changeSearchInput = this.changeSearchInput.bind(this);
    this.changeSearchValue = this.changeSearchValue.bind(this);
    this.changeSearchValueThrottled = _.throttle(this.changeSearchValue.bind(this), 1000);
    this.getDailyDate = this.getDailyDate.bind(this);
    this.getDailyDateByDOW = this.getDailyDateByDOW.bind(this);
    this.onClickMulti = this.onClickMulti.bind(this);
    this.onClickSingle = this.onClickSingle.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.personAvailability = this.personAvailability.bind(this);
    this.personTaskAssignment = this.personTaskAssignment.bind(this);
    this.renderAssignments = this.renderAssignments.bind(this);
    this.renderAvailability = this.renderAvailability.bind(this);
    this.renderAvatar = this.renderAvatar.bind(this);
    this.renderFooter = this.renderFooter.bind(this);
    this.renderHeader = this.renderHeader.bind(this);
    this.renderModalHeader = this.renderModalHeader.bind(this);
    this.renderMulti = this.renderMulti.bind(this);
    this.renderOptions = this.renderOptions.bind(this);
    this.renderSingle = this.renderSingle.bind(this);
    this.selectedInOptions = this.selectedInOptions.bind(this);
  }

  componentWillMount() {
    this.setState({ selected: this.props.selected });
  }

  onClickMulti(indexSelectedOption, option) {
    const { onSelect, onRemovePills } = this.props;

    return () => {
      if (indexSelectedOption !== -1) {
        onRemovePills(indexSelectedOption, option);
      } else {
        onSelect(option);
      }
    };
  }

  onClickSingle(option) {
    const { onSelect } = this.props;

    return () => {
      onSelect(option);
      this.onSubmit();
    };
  }

  onClose() {
    const { selected } = this.state;
    const { resetSelectedElements, onClose } = this.props;
    if (resetSelectedElements) resetSelectedElements(selected);
    onClose();
  }

  onSubmit() {
    const { onSubmit, onClose } = this.props;
    if (onSubmit) onSubmit();
    onClose();
  }

  getDailyDate() {
    const { activeDate } = this.props;
    return formatDate(activeDate, false, 'YYYY-MM-DD');
  }

  getDailyDateByDOW() {
    const { activeDate } = this.props;
    return _.lowerCase(formatDate(activeDate, false, 'dddd'));
  }

  selectedInOptions(code) {
    return _.findIndex(this.props.selected, option => option === code || option.code === code);
  }

  changeSearchValue(newValue) {
    this.setState({
      searchFilter: newValue,
    });
  }

  changeSearchInput(newValue) {
    this.changeSearchValueThrottled(newValue);
  }

  personAvailability(personId) {
    const { personAvailabilityByDOWFromSixteenHours } = this.props;
    return personAvailabilityByDOWFromSixteenHours(personId, this.getDailyDateByDOW());
  }

  personTaskAssignment(personId) {
    const { personTaskAssignmentStats } = this.props;

    return personTaskAssignmentStats(personId, this.getDailyDate());
  }

  renderFooter() {
    const { primaryText, secondaryText, selectConflict, customFooter } = this.props;

    if (selectConflict) {
      return customFooter;
    }

    return (
      <div className="modal-selectV2__footer">
        <Buttons.TextButton
          autoWidth
          className="modal-selectV2__footer--cancel-button"
          onClick={this.onClose}
          theme="default"
          size="large"
        >
          {secondaryText}
        </Buttons.TextButton>
        <Buttons.TextButton
          className="modal-selectV2__footer--primary-button"
          onClick={this.onSubmit}
          size="large"
        >
          {primaryText}
        </Buttons.TextButton>
      </div>
    );
  }

  renderMulti(option, index, withGraphBars) {
    const optionValue = _.get(option, 'value');
    const optionLabel = _.get(option, 'label');
    const optionDescription = _.get(option, 'description');
    const indexSelectedOption = this.selectedInOptions(optionValue);
    const isServicePartner = _.get(option, 'isServicePartner');
    const showBars = withGraphBars && !isServicePartner;

    return (
      <div
        className={classnames('modal-selectV2__single-option', { '--with-graph-bar': showBars })}
        key={`multi-option-item-${index}`}
      >
        {this.renderAvatar(option)}
        {showBars ? (
          <Fragment>
            <div className="modal-selectV2__bar-container">
              <div className="task-assignment-row__username">{optionLabel}</div>
              {this.renderAvailability(optionValue)}
              {this.renderAssignments(optionValue)}
            </div>
            <Bars.CheckboxBar
              key={optionValue}
              onClick={this.onClickMulti(indexSelectedOption, option)}
              isSelected={indexSelectedOption !== -1}
            />
          </Fragment>
        ) : (
          <Bars.CheckboxBar
            isSelected={indexSelectedOption !== -1}
            key={optionValue}
            onClick={this.onClickMulti(indexSelectedOption, option)}
            primaryText={optionLabel}
            secondaryText={optionDescription}
          />
        )}
      </div>
    );
  }

  renderAvatar(option) {
    const { getPersonFromId, showPersonAvatar } = this.props;

    if (!showPersonAvatar) {
      return null;
    }

    const person = getPersonFromId(option.value);
    if (person) {
      return <Avatar name={option.label} size="xxsmall" person={person} />;
    }

    return <Avatar name={option.label} size="xxsmall" />;
  }

  renderSingle(option, index, withGraphBars) {
    const showBars = withGraphBars;

    return (
      <div
        className={classnames('modal-selectV2__single-option', { '--with-graph-bar': showBars })}
        key={`single-option-item-${index}`}
      >
        {this.renderAvatar(option)}
        {showBars ? (
          <Fragment>
            <div className="modal-selectV2__bar-container">
              <div className="task-assignment-row__username">{option.label}</div>
              {this.renderAvailability(option.value)}
              {this.renderAssignments(option.value)}
            </div>
            <Bars.IconBar key={option.value} onClick={this.onClickSingle(option)} />
          </Fragment>
        ) : (
          <Bars.IconBar
            key={option.value}
            primaryText={option.label}
            secondaryText={option.description}
            onClick={this.onClickSingle(option)}
          />
        )}
      </div>
    );
  }

  renderAvailability(personId) {
    return (
      <AvailabilityBar
        personAvailability={this.personAvailability(personId)}
        title="Avail:"
        withAsideHourLabels
        withHourLabels
      />
    );
  }

  renderAssignments(personId) {
    return (
      <AssignmentBar
        personTaskAssignmentStats={this.personTaskAssignment(personId)}
        personAvailability={this.personAvailability(personId)}
      />
    );
  }

  renderOptions() {
    const { options, optionLabel, multi, order, withGraphBars } = this.props;
    const { searchFilter } = this.state;
    const searchedOptions = searchObjects(_.values(options), searchFilter, [optionLabel]);
    const renderedOptions = order
      ? _.orderBy(searchedOptions, searched => _.toLower(searched[optionLabel]))
      : searchedOptions;

    return (
      <div className="modal-selectV2__options-wrapper">
        {_.map(renderedOptions, (option, index) =>
          multi
            ? this.renderMulti(option, index, withGraphBars)
            : this.renderSingle(option, index, withGraphBars),
        )}
      </div>
    );
  }

  renderModalHeader() {
    const { title, secondaryText, subtitle } = this.props;
    return (
      <div className="modal-popup__title modal-selectV2__header-title">
        <h4>{title}</h4>
        {secondaryText && (
          <Buttons.TextButton
            autoWidth
            onClick={this.onClose}
            theme={Buttons.constants.BUTTON_THEMES.LINK}
          >
            <div className="icon-chevron-left button__fetching-wrapper">{secondaryText}</div>
          </Buttons.TextButton>
        )}
        {subtitle && <h3>{subtitle}</h3>}
      </div>
    );
  }

  renderHeader() {
    const { title } = this.props;
    return (
      <div className="modal-popup__header">
        <h4 className="modal-popup__modal-title">{title}</h4>
      </div>
    );
  }

  render() {
    const {
      className,
      full,
      headerPhoto,
      multi,
      onModal,
      showPersonAvatar,
      smallModal,
      title,
      wrapClassName,
    } = this.props;

    return (
      <Modal
        className={className}
        closeIconName="close"
        footer={multi ? this.renderFooter() : null}
        full={full}
        header={!multi ? this.renderModalHeader() : this.renderHeader()}
        headerPhoto={headerPhoto}
        modalClassName={classnames('modal-selectV2 style-guide', {
          'modal-selectV2--on-modal': onModal,
          'modal-selectV2--with-avatar': showPersonAvatar,
          'modal-selectV2--small-modal': smallModal,
        })}
        onClose={this.onClose}
        title={title}
        withBodyScroll
        withCloseIcon
        wrapClassName={wrapClassName}
      >
        <SearchInputWithState
          className="modal-selectV2__search"
          iconBefore="search"
          id="modal-select-search-input"
          onChange={this.changeSearchInput}
        />
        {this.renderOptions()}
      </Modal>
    );
  }
}

ModalSelect.propTypes = {
  activeDate: PropTypes.shape({}),
  className: PropTypes.string,
  customFooter: PropTypes.node,
  full: PropTypes.bool,
  getPersonFromId: PropTypes.func,
  headerPhoto: PropTypes.node,
  multi: PropTypes.bool,
  onClose: PropTypes.func,
  onModal: PropTypes.bool,
  onRemovePills: PropTypes.func,
  onSelect: PropTypes.func,
  onSubmit: PropTypes.func,
  optionLabel: PropTypes.string,
  options: PropTypes.array.isRequired,
  order: PropTypes.bool,
  primaryText: PropTypes.string,
  resetSelectedElements: PropTypes.func,
  secondaryText: PropTypes.string,
  selectConflict: PropTypes.bool,
  selected: PropTypes.array,
  showPersonAvatar: PropTypes.bool,
  smallModal: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  personAvailabilityByDOWFromSixteenHours: PropTypes.func,
  personTaskAssignmentStats: PropTypes.func,
  withGraphBars: PropTypes.bool,
  wrapClassName: PropTypes.string,
};

ModalSelect.defaultProps = {
  customFooter: null,
  onModal: false,
  onSelect: () => {},
  optionLabel: 'label',
  order: true,
  primaryText: 'Select',
  secondaryText: 'Cancel',
  selectConflict: false,
  showPersonAvatar: false,
  smallModal: false,
  wrapClassName: '',
};

const mapStateToProps = state => ({
  activeDate: selectors.getActiveDate(state),
  getPersonFromId: personId => datastore.selectors.company.getPerson(state, personId),
  personAvailabilityByDOWFromSixteenHours: (personId, day) =>
    datastore.selectors.company.getPersonAvailabilityByDOWFromSixteenHours(state, personId, day),
  personTaskAssignmentStats: (id, day) => selectors.getPersonTaskAssignmentStats(state, id, day),
});

export default connect(mapStateToProps)(ModalSelect);
